// Color palette per theme
export const themeColors = [
  { bar: '#5CB24F', link: '#5CB24F' }, // green
  { bar: '#2F6CC4', link: '#2F6CC4' }, // blue
  { bar: '#9B59B6', link: '#9B59B6' }, // purple
  { bar: '#E67E22', link: '#E67E22' }, // orange
  { bar: '#16A085', link: '#16A085' } // teal
]
